<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class=" d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-user-plus text-primary"></i> Export Student</h5>
      </div>
      <hr>
      <div class="row g-3">
      <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.clsID)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.clsID = item._id">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            </div>
        <div class=" col-md-3">
          <label class="form-label">Section<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.sectionID">
            <option selected=""></option>
            <option v-for="(item, index) in
              secList" :key="index" :value="item._id"> {{ item.Name }} </option>
          </select>
        </div>
        <div class="col-md-3 text-start  mt-5">
        <button class="btn btn-sm btn-success me-1" @click="save()"><i class="fas fa-search text-white me-1"></i>Go</button>
        <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fas fa-times-circle me-1"></i> Cancel</button>
      </div>
       <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      </div>
      <div v-if="showexport">
      <div class="col-md-7">
  <div class="d-flex justify-content-end align-items-center mb-2 mt-2">
    <div class="d-flex align-items-center gap-1">
      <i class="fa fa-print text-primary cursor-pointer fs-4" role="button" @click="print()"></i>
      <i class="fa fa-download fs-4 cursor-pointer" role="button" @click="downloadPDF()"></i>
    </div>
  </div>
</div>
      <div class="col-md-7 col-sm-12 border-box container-fluid container-a ms-0" ref="printSection" id="pdf-section">
        <div class="mt-0">
          <div class="col-md-12">
             <div class="d-flex justify-content-center align-items-center text-center">
            <img :src="getUrl(profile.Image)" alt="School Logo" class="me-1 mb-3 avatar-lg"/>
            <div>
              <p class="fw-bold fs-2 mb-0">{{ profile.Name }}</p>
              <p class="mb-0 ">{{ profile.Address }}</p>
              <p class="mb-0 ">{{ profile.Email }}</p>
              <p class="mb-0 mb-2">+91 {{ profile.MobileNo }}</p>
            </div>
          </div>
          </div>
          <div class="col-md-12 text-left">
            <label class="form-label">
             <strong> Class :</strong> <span class="text-danger me-2"> {{clsList.find(cls => cls._id == Obj.clsID)?.name || ''}} </span>
            </label>
            <label class="form-label">
              <strong>Section :</strong> <span class="text-primary"> {{secList.find(sec => sec._id == Obj.sectionID)?.Name || ''}} </span>
            </label>
          </div>
          <div class="row">
            <div class="col-md-12 table-responsive">
             <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
          </div>
             <DataTable v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10" :searchTxt="false" />
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import DataTable from "@/components/Common/DataTable.vue";
import {  api } from '@/utils/helpers.js';
import html2pdf from 'html2pdf.js';
import { ref,} from 'vue'
import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList, profile } = schoolStore();
const printSection = ref(null)
  const  Obj = ref( {clsID: "", sectionID: "",})
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const errors = ref({})
    const showexport= ref(false)
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Roll No', key: 'rollNo' },
  { label: 'Name', key: 'firstName' },
  { label: 'Class', key: 'clsID' }
]);
const rows=ref([])
 const downloadPDF= () => {
      const element = printSection.value;
      const images = element.querySelectorAll("img");
      const imagePromises = Array.from(images).map(img => {
        return new Promise(resolve => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = img.onerror = () => resolve();
          }
        });
      });
      Promise.all(imagePromises).then(() => {
        const opt = {
          margin: 0.5,
          filename: 'Export-students.pdf',
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        };

        html2pdf().set(opt).from(element).save();
      });
    }
   const print = () => {
      const printContents = printSection.value.innerHTML;
  const printWindow = window.open('', '', 'width=900,height=700');
  printWindow.document.write(`
    <html>
      <head>
        <style>
        @page{size: portrait}
          body { font-family: Arial, sans-serif; padding: 20px; } table{width:100%;}
          table, th, td { border: 1px solid #b0aaaa; border-collapse: collapse; padding: 8px; text-align: left; }
          img { max-width: 100px; height: 100px; margin-left:150px; margin-right:5px; margin-top:10px;}
          .fs-2{font-size:25px; margin-top:10px; font-weight:bold;}
          .d-flex{display: flex; text-align: center;}
          .mb-0{margin-bottom:-10px;} .mb-2{margin-bottom:20px;}
          .text-danger{color:red; margin-right:15px;}
          .text-primary{color:blue;} .mt-0 { border: 1px solid black; width:100%; }
        </style>
      </head>
       <body onload="window.print(); window.close();">
        ${printContents}
      </body>
    </html>
  `);
  printWindow.document.close();
}
const save= async() => {
      const fields = {
        Class: { value: Obj.value.clsID, validators: [isRequired], },
        Section: { value: Obj.value.sectionID, validators: [isRequired], },
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) { loadData();
        showexport.value=true;
       }
  }
    const reset= async() => {
      Obj.value = { clsID: "", sectionID: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
       showexport.value=false;
    }
     const progress = ref(0)
    const loadData= async()=> {
     let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      const params = new URLSearchParams();
      if (Obj.value.clsID) { params.append("clsID", Obj.value.clsID); }
      if (Obj.value.sectionID) { params.append("sectionID", Obj.value.sectionID); }
      await api.get(`/students/list?${params.toString()}`) .then((response) => { rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1, 
        clsID: `${clsList.value.find(c => c._id === item.clsID)?.name || ''}${clsList.value.find(c => c._id === item.clsID)?.name ? (secList.value.find(s => s._id === item.sectionID)?.Name ? ' (' + secList.value.find(s => s._id === item.sectionID)?.Name + ')' : '') : ''}`,
      firstName: `${item.firstName} ${item.lastName} ` })); 
          progress.value = 0
          clearInterval(progressInterval)
         });
    }
    const getUrl=(img)=> {
      let imgUrl = !img
        ? "/images/Logo.png"
        : img.startsWith("..")
          ? img.substring(2)
          : img;
      
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
    }
</script>
<style>
#pdf-section table,
#pdf-section th,
#pdf-section td {
  border: 1px solid #b0aaaa !important;
  border-collapse: collapse !important;
}
 .border-box {
    border: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    padding:10px;
    margin-top: 10px;
  }
  @media (max-width: 375px) {
     .fs-2 {
     font-size:18px!important;
     }
  }
</style>